<template>
  <div>
    <span v-if="modal === null">&nbsp;</span>
    <ExtensionPanel
      v-else-if="!modal"
      ref="panel"
      :cancel-disabled="read_only"
      :cancel-title="cancel_label_"
      :hide_buttons="hide_buttons"
      :is_save_loading="is_save_loading"
      :ok-disabled="read_only || ok_disabled"
      :ok-title="ok_label_"
      :panel-zindex="10000"
      :panelid="panel_id"
      :ro="read_only"
      :show-rewind="showRewind"
      :show_save="!hide_footer"
      :size="size"
      :title="panel_title"
      @cancel="doClose()"
      @close="doClose()"
      @rewind-form="$emit('rewind-form')"
      @submit="doSubmit"
    >
      <slot />
      <template #footer>
        <slot name="footer" />
      </template>
    </ExtensionPanel>
    <b-modal
      v-else
      :id="panel_id"
      :cancel-disabled="read_only"
      :cancel-title="cancel_label_"
      cancel-variant="light"
      :data-testid="`${panel_id}-modal`"
      :hide-footer="hide_footer"
      :hide-header="hide_header"
      :no-close-on-backdrop="no_close_on_backdrop"
      :no-close-on-esc="no_close_on_esc"
      :no-enforce-focus="true"
      :ok-disabled="read_only || ok_disabled"
      :ok-only="ok_only"
      ok-variant="outline-primary"
      :scrollable="isModalScrollable"
      :size="size"
      :title="panel_title"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
      @hide="onModalHide"
      @ok.prevent="doSubmit"
    >
      <slot />
      <template
        v-for="slotName in Object.keys($scopedSlots)"
        #[slotName]="scope"
      >
        <slot
          v-bind="scope"
          :name="slotName"
        />
      </template>
      <template
        v-if="read_only"
        #modal-footer
      >
        <div>&nbsp;</div>
      </template>
      <template #modal-ok>
        <div data-testid="ok-button">
          <b-spinner
            v-if="is_save_loading"
            small
          />
          <template v-else>{{ ok_label_ }}</template>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'
import ExtensionPanel from '@/components/ui/ExtensionPanel.vue'
import { rootBus } from '@/contexts/shared/event-bus/RootBus'

export default {
  name: 'AcisoForm',
  components: { ExtensionPanel },
  props: {
    read_only: {
      type: Boolean,
      default: false,
    },
    hide_buttons: {
      type: Boolean,
      default: false,
    },
    no_close_on_backdrop: {
      type: Boolean,
      default: true,
    },
    no_close_on_esc: {
      type: Boolean,
      default: true,
    },
    hide_footer: {
      type: Boolean,
      default: false,
    },
    hide_header: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: null,
      required: true,
    },
    panel_id: String,
    panel_title: String,
    ok_label: {
      type: String,
    },
    cancel_label: {
      type: String,
    },
    size: {
      type: String,
      default: 'lg',
    },
    showRewind: {
      type: Boolean,
      default: false,
    },
    ok_only: {
      type: Boolean,
      default: false,
    },
    ok_disabled: {
      type: Boolean,
      default: false,
    },
    is_save_loading: {
      type: Boolean,
      default: false,
    },
    isModalScrollable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      ok_label_: '',
      cancel_label_: '',
    }
  },
  mounted: function () {
    if (this.ok_label) {
      this.ok_label_ = this.ok_label
    } else {
      this.ok_label_ = this._('Save')
    }
    if (this.cancel_label) {
      this.cancel_label_ = this.cancel_label
    } else {
      this.cancel_label_ = this._('Cancel')
    }
  },
  methods: {
    doSubmit: throttle(
      function () {
        if (!this.is_save_loading) {
          this.$emit('submit')
        }
      },
      1000,
      { leading: true, trailing: false }
    ),
    show() {
      if (!this.modal) {
        this.$log.debug(this.$refs)
        this.$refs.panel.show()
      } else {
        this.$bvModal.show(this.panel_id)
      }
    },
    hide() {
      if (!this.modal) {
        this.$refs.panel.hide()
      } else {
        this.$bvModal.hide(this.panel_id)
      }
    },
    doClose() {
      this.$emit('cancel')
    },
    onModalHide() {
      this.$emit('hideModal')
      rootBus.emit('bv::modal::hide')
    },
  },
}
</script>
